document.addEventListener('DOMContentLoaded', function() {
  const openOptionModal = document.querySelectorAll('.js-open-option-modal');
  const addCartButtons = document.querySelectorAll('.js-add-cart');
  const addCartFloat = document.querySelector('.js-add-cart-float');
  const productBlockWrapper = document.querySelectorAll('.js-product-block--wrapper');

  function lockBody() {
    document.body.style.overflow = 'hidden';
  }

  function unlockBody() {
    document.body.style.overflow = '';
  }

  if (openOptionModal && productBlockWrapper.length > 0) {
    openOptionModal.forEach(function(modal) {
      modal.addEventListener('click', function(e) {
        e.stopPropagation();
        productBlockWrapper[0].classList.add('is-open');
        lockBody();
      });
    });
  }

  function handleModalButtonVisibility() {
    if (!addCartButtons || !addCartFloat || addCartButtons.length === 0) {
      return;
    }

    const firstAddCartButton = addCartButtons[0];
    let lastScrollY = window.scrollY;
    
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        const rect = entry.boundingClientRect;
        const currentScrollY = window.scrollY;
        const isScrollingUp = currentScrollY > lastScrollY;
        
        if (!entry.isIntersecting) {
          if (rect.bottom < 0 && isScrollingUp) {
            addCartFloat.classList.add('is-visible');
          }
        } else {
          addCartFloat.classList.remove('is-visible');
        }
        
        lastScrollY = currentScrollY;
      });
    }, {
      threshold: 0,
      rootMargin: '0px'
    });

    const mutationObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        let shouldShowFloat = false;

        if (mutation.type === 'attributes' && mutation.target === firstAddCartButton) {
          const computedStyle = window.getComputedStyle(firstAddCartButton);
          if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden' || computedStyle.opacity === '0') {
            shouldShowFloat = true;
          }
        }
        
        if (mutation.type === 'childList') {
          mutation.removedNodes.forEach(function(node) {
            if (node === firstAddCartButton || (node.nodeType === 1 && node.contains && node.contains(firstAddCartButton))) {
              shouldShowFloat = true;
            }
          });
        }

        if (shouldShowFloat) {
          addCartFloat.classList.add('is-visible');
        }
      });
    });

    observer.observe(firstAddCartButton);
    mutationObserver.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['style', 'class']
    });
  }

  handleModalButtonVisibility();

  productBlockWrapper.forEach(function(wrapper) {
    wrapper.addEventListener('click', function(e) {
      if (e.target === wrapper) {
        wrapper.classList.remove('is-open');
        unlockBody();
      }
    });
  });

  /* ------------------------------
    バリアント切り替え時にモーダル内画像を差し替え
  ------------------------------*/
  function getSizedSrc(src, width) {
    if (!src) {
      return src;
    }
    /*  テーマのリサイズユーティリティがあれば利用  */
    if (window.theme && theme.Images && theme.Images.getSizedImageUrl) {
      const sized = theme.Images.getSizedImageUrl(src, width + 'x');
      if (sized) {
        return sized;
      }
    }
    /*  フォールバック: ファイル名にサイズを差し込む  */
    return src.replace(/(\.[^.?]+)(\?.*)?$/, '_' + width + 'x$1$2');
  }

  function updateModalVariantImage(variant) {
    if (!variant || !variant.featured_image) {
      return;
    }
    const modalImages = document.querySelectorAll('.js-modal-variant-image');
    const newSrc = getSizedSrc(variant.featured_image.src, 800);
    modalImages.forEach(function(img) {
      if (!newSrc || img.getAttribute('src') === newSrc) {
        return;
      }
      img.setAttribute('src', newSrc);
      if (variant.featured_image.alt) {
        img.setAttribute('alt', variant.featured_image.alt);
      }
    });
  }

  document.addEventListener('variant:change', function(e) {
    updateModalVariantImage(e.detail && e.detail.variant);
  });

  /* ------------------------------
    全バリアント画像を事前読み込み（切り替えを高速化）
  ------------------------------*/
  let variantImagesPreloaded = false;
  function preloadVariantImages() {
    if (variantImagesPreloaded) {
      return;
    }
    variantImagesPreloaded = true;

    const srcHolder = document.querySelector('.js-modal-variant-image-srcs');
    if (!srcHolder) {
      return;
    }
    let srcs = [];
    try {
      srcs = JSON.parse(srcHolder.textContent) || [];
    } catch (err) {
      return;
    }
    srcs.forEach(function(src) {
      const preloadImg = new Image();
      preloadImg.src = src;
    });
  }

  openOptionModal.forEach(function(modal) {
    modal.addEventListener('click', preloadVariantImages);
  });

  if (addCartFloat) {
    addCartFloat.addEventListener('click', function(e) {
      e.stopPropagation();
      if (productBlockWrapper.length > 0) {
        productBlockWrapper[0].classList.add('is-open');
        lockBody();
      }
    });
  }
});